import type { MeResponse } from '../widget-api/auth-me';
import { isOrgStaffBaseRoleLine } from './embed-route-policy';

/** Легаси slug JWT той же staff-линии (не путать с product persona). */
export function isLegacyTrainerJwtRole(role: string | null | undefined): boolean {
  if (role == null || role === '') return false;
  return role.toLowerCase().trim() === 'trainer';
}

/**
 * Сценарий «тренер fitness» (как `domain.HasFitnessTrainerPersona` / `fitness_trainer_persona` в API).
 * Канон: bool с бэка; иначе совместимость по role + `trainer_placements` (старые кеши/клиенты).
 */
export function hasFitnessTrainerPersonaFromMe(me: MeResponse | null | undefined): boolean {
  if (me == null) return false;
  if (typeof me.fitness_trainer_persona === 'boolean') {
    return me.fitness_trainer_persona;
  }
  if (!isOrgStaffBaseRoleLine(me.role)) return false;
  const n = me.trainer_placements?.length ?? 0;
  return isLegacyTrainerJwtRole(me.role) || n > 0;
}

/**
 * Пользователь на org **staff-линии** (ядро: staff или легаси `trainer` в JWT).
 * Предпочитайте: `fitness_trainer_runtime != null` с API; иначе — проверка строки `role` (как в `domain.IsOrgStaffBaseRoleLine`).
 */
export function isOrgStaffLineWithRuntime(me: MeResponse | null | undefined): boolean {
  if (me == null) return false;
  if (me.fitness_trainer_runtime != null) {
    return true;
  }
  return isOrgStaffBaseRoleLine(me.role);
}
